<template>
  <div>
    <span v-for="(language, index) in languages" :key="language.locale">
      <a
        :class="language.locale === locale ? 'nav__link-href nav__link-href--selected' : 'nav__link-href'"
        :href="getUrl(language.link, language.locale)"
        style="vertical-align: middle"
        :aria-label="`${$t('language_selector')}: ${language.name} `"
      >
        {{ language.name }}
      </a>
      <span v-if="index !== languages.length - 1" class="mx-2" style="font-size: 24px; vertical-align: middle">|</span>
    </span>
  </div>
</template>

<script>
export default {
  props: ["blok"],
  data() {
    return {
      tenant: this.$store.getters["registration/tenant"],
      menu: false,
      languages: [
        {
          link: "/register/",
          name: "EN",
          locale: "en",
        },
        {
          link: "/de/Anmeldung/",
          name: "DE",
          locale: "de",
        },
      ],
    };
  },
  methods: {
    getUrl(link, locale) {
      const { origin, search } = window.location;

      if (this.tenant === "certible") {
        return `${origin}${link}${search}`;
      }

      if (search) {
        const params = new URLSearchParams(search);
        if (params.has("locale")) {
          params.delete("locale");
        }
        params.append("locale", locale);
        return `${origin}?${params.toString()}`;
      }

      return `${origin}?locale=${locale}`;
    },
  },
  computed: {
    locale() {
      return this.$store.getters["registration/locale"];
    },
  },
};
</script>

<style scoped>
.nav__link-href {
  text-decoration: none;
  color: #1e2939;
}
.nav__link-href:hover {
  color: #99a1af;
}
.nav__link-href--selected {
  font-weight: 600;
}
</style>
